// The store products browser's own words (aldoo-ra Admin/Store/Products,
// DEFAULT_LABELS) in the site's language, for the vendor's product list.
import { useMemo } from "react"
import usePortalTexts from "./texts/usePortalTexts"
import { PRODUCTS } from "./texts/bundles"

/** `labels` for the store products browser in a vendor's views. */
export default function useVendorProductLabels() {
  const t = usePortalTexts(PRODUCTS)
  return useMemo(
    () => ({
      productName: t`Product Name`,
      price: t`Price`,
      type: t`Type`,
      actions: t`Actions`,
      priceMin: t`Min`,
      priceMax: t`Max`,
      priceRange: t`Range`,
      priceRangeInvalid: t`The minimum is above the maximum`,
      priceFilterFailed: t`Failed to filter by price`,
      search: t`Search...`,
      noProducts: t`No products added yet`,
      noPriceModel: t`No price model`,
      addPrice: t`Add New Price`,
      confirmDeleteTitle: t`Confirm Delete`,
      confirmDeleteMessage: t`Are you sure you want to delete "%s"?`,
      thisProduct: t`this product`,
      delete: t`Delete`,
      cancel: t`Cancel`,
      deleted: t`Product deleted`,
    }),
    [t]
  )
}
